import { render, staticRenderFns } from "./GenericsBranches.vue?vue&type=template&id=ac1c0986"
import script from "./GenericsBranches.vue?vue&type=script&lang=js"
export * from "./GenericsBranches.vue?vue&type=script&lang=js"
import style0 from "./GenericsBranches.vue?vue&type=style&index=0&id=ac1c0986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports